/*
 * @Author: DouDou
 * @LastEditors: DouDou
 * @Date: 2020-09-27 18:32:36
 * @LastEditTime: 2020-10-14 14:07:10
 * @Description: File description
 */
import { XesAxios } from '@xes/terra-utils'

export default {
  // 检测登录态接口 - 登录页
  checkLogin () {
    return XesAxios.get('https://login.xueersi.com/LoginV1/checkLogin', {
      params: { user_info: 1 }
    })
  },
  // 获取年级列表接口 - 注册页
  getGradeList () {
    return XesAxios.get('https://reg.xueersi.com/RegV1/gradeList')
  },
  // 获取用户分享活动信息接口 - 活动页
  getShareData () {
    return XesAxios.post('https://growth.xueersi.com/invite/activity/info', { sGroupId: 20001, giftType: '' })
  },
  // 辅导老师分享短链生成接口
  getPosterData (data) {
    return XesAxios.post('https://booster.xueersi.com/activity/shortUrl/create', data)
  },
  // 绑定辅导老师用户关系
  bindUserRelation (data) {
    return XesAxios.post('https://booster.xueersi.com/user/relation/create/tutorThree', data)
  },
  // 获取页面配置 - 奖励明细
  getRewardPageinfo () {
    return XesAxios.get('https://invite.xueersi.com/ac/userdetail', { params: { sGroupId: 20001 } })
  },
  // 获取“推荐有奖” 分页信息
  getRecommendPageinfo (pageNum, pageSize) {
    return XesAxios.get('https://invite.xueersi.com/ac/userdetail/invitelist', {
      params: { sGroupId: 20001, pageSize: pageSize, pageNum: pageNum }
    })
  },
  // 获取 “特别福利” 分页信息
  getWelfarePageinfo (pageNum, pageSize) {
    return XesAxios.get('https://invite.xueersi.com/ac/userdetail/extralist', {
      params: { sGroupId: 20001, pageSize: pageSize, pageNum: pageNum }
    })
  },
  // 获取“累计提现记录信息”
  getSuccessList () {
    return XesAxios.get('https://invite.xueersi.com/ac/usercash', {
      params: {
        sGroupId: 20001
      }
    })
  },
  // 获取“累计提现记录信息” 分页信息
  getSuccessListPageinfo (pageNum, pageSize) {
    return XesAxios.get('https://invite.xueersi.com/ac/usercash/list', {
      params: { sGroupId: 20001, pageSize: pageSize, pageNum: pageNum }
    })
  },
  // 获取公告消息
  getmeginfo () {
    return XesAxios.get('https://invite.xueersi.com/ac/notice', {
      params: { sGroupId: 20001 }
    })
  },
  // 校验用户提现信息接口 - 列表页
  checkUserCash () {
    return XesAxios.post('https://growth.xueersi.com/invite/activity/checkusercash')
  },
  // 发送用户提现接口 - 列表页
  userBonusCash (id_card, realname, isCheck = 0) {
    return XesAxios.post('https://growth.xueersi.com/invite/activity/userbonuscash', {
      id_card,
      realname,
      not_check_name: isCheck
    })
  },
  // 获取短链接
  getShortUrl (url) {
    return new Promise((resolve, reject) => {
      XesAxios.post('//growth.xueersi.com/api/shortUrl', {
        url
      }).then(res => {
        if (res.code === 0) {
          resolve(res.data.url)
        } else {
          reject(new Error(res.message || '请求出错'))
        }
      })
    })
  },
  /**
   * 获取小程序二维码
   * 个性海报只传了前两个参数。
   * @param {string} userId -
   * @param {string} sourceId -
   * @param {string} postType - 海报类型。0:默认，1:个性
   */
  getMiniAppQRcode (tutorId, userId, sourceId, postType = 1, posterId = '', sGroupId = 20001) {
    return XesAxios.get('https://booster.xueersi.com/poster/wechat/getWxAppCode', {
      params: { tutorId, userId, sourceId, postType, posterId, sGroupId }
    }).then(result => {
      // 解决海报合成成跨域问题 // hw.xesimg.com
      let url = result.data.url
      // url = 'https://xesfiles.xesimg.com/wechatapi/miniProgram/appCode/3d09acf07e12fe868234f773a43093a0.jpeg'
      url = url.replace(/\/\/.*?\.xesimg.com(:808\d)?\//i, '//activity.xueersi.com/oss2/')
      return url
    })
  },
  // 获取个性化海报接口
  getDiyPoster () {
    return XesAxios.get('https://booster.xueersi.com/poster/wechat/getPersonalizedPoster')
  },
  // 获取默认海报接口
  getDefaultPoster () {
    return XesAxios.get('https://booster.xueersi.com/poster/wechat/getDefaultPoster')
  },
  /* v3.2 版本新加 */
  getHomeData () {
    return XesAxios.post('https://booster.xueersi.com/activity/index')
  },
  // 获取用户（可得金币）分享次数
  getShareCountForGold () {
    return XesAxios.post('https://booster.xueersi.com/user/relation/invitedShare/getNum')
  },
  // 增加用户（可得金币）分享次数
  increaseShareCountForGold () {
    return XesAxios.post('https://booster.xueersi.com/user/relation/invitedShare/incrNum')
  },
  // 获取用户兑换课程数据
  getCourseExchangeData () {
    return XesAxios.post('https://booster.xueersi.com/activity/course/list')
  },
  exchangeCourse (courseId = '') {
    return XesAxios.post('https://booster.xueersi.com/activity/course/change', { courseId })
  }
}
